module.exports = __webpack_public_path__ + "static/media/Quake Explorer.9e40f333.mp4";